module.exports = __webpack_public_path__ + "img/129.4.e08ddb6a.png";